import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledDescription = styled(Text)`
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	opacity: 0.75;
`;

const StyledCodeInputWrapper = styled.div`
	position: relative;
	width: 100%;
`;

const StyledCodeInputError = styled(Text)`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #c71e1e;
	font-size: 16px;
	font-weight: 400;
	pointer-events: none;
`;

const StyledButtonsRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 10px;
`;

const StyledButtonsGroup = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
	margin-top: 10px;
`;

export {
	StyledBody,
	StyledButtonsGroup,
	StyledButtonsRow,
	StyledCodeInputError,
	StyledCodeInputWrapper,
	StyledDescription,
};
